<template lang="pug">
  .div
    .columns
      .column.is-3.is-strech
        span
          b Proveedor 
      .column.is-9.is-strech
        span.tag.is-black
          b {{ requisicion.nombreProvSel }}
    .columns
      .column.is-3.is-strech
        span
          b R.F.C.
      .column.is-9.is-strech
        small
          b {{ requisicion.rfc }}
    .columns
      .column.is-3.is-strech
        span
          b Dirección
      .column.is-9.is-strech
        small
          b {{ `${requisicion.direccion}, C.P. ${requisicion.cp}` }}
    .columns
      .column.is-3.is-strech
        span
          b Teléfono 
      .column.is-9.is-strech
        small
          b {{ `Tél. ${requisicion.telefono} Ext. ${requisicion.extension}` }}
    .columns
      .column.is-3.is-strech
        span
          b Email
      .column.is-9.is-strech
          b 
            i.far.fa-envelope
            | &nbsp 
            small {{ requisicion.correo }}
    .columns
      .column.is-3.is-strech
        span
          b Contacto 
      .column.is-9.is-strech
          b 
            span {{ requisicion.contacto }} 
    .columns
      .column.is-3.is-strech
        span
          b {{ parseInt(requisicion.moneda) == 0 ? 'Mon. Nacional' : 'Mon. Extranjera' }}
      .column.is-9.is-strech
        b Banco: 
          small {{ requisicion.banco }} 
          | Cuenta: 
          small {{ requisicion.cuenta }} 
          | Clabe: 
          small {{ requisicion.clabe }}
    .columns
      .column.is-3.is-strech
        span
          b Descripción
      .column.is-9.is-strech
        small
          b Tipo: &nbsp
          b(v-if="requisicion.servicio") Servicio |&nbsp
          b(v-else) Material |&nbsp
          b Inmediata: &nbsp
          b(v-if="parseInt(requisicion.entrega) == 0 ") Si |&nbsp
          b(v-else) {{ requisicion.entrega }} días |
          b Condiciones de Pago: &nbsp
          b {{ requisicion.condiciones }}% |&nbsp
          b Crédito: &nbsp
          b(v-if="requisicion.credito")
            | SI
          b(v-else)
            | NO
    .columns
      .column.is-3.is-strech
        span(:class="parseInt(requisicion.proveedorSel) === 1? 'tag is-black' : ''")
          b Proveedor 1
      .column.is-9.is-strech
        small
          span(:class="parseInt(requisicion.proveedorSel) === 1? 'tag is-black' : ''")
            b {{ requisicion.nombreProv1 }}
          br
          span(:class="parseInt(requisicion.proveedorSel) === 1? 'tag is-black' : ''" v-if="requisicion.monedaP1 ==='0'") 
            b {{requisicion.totalP1 | currency }}
          span(:class="parseInt(requisicion.proveedorSel) === 1? 'tag is-black' : ''" v-else) 
            b USD {{requisicion.totalP1 | currency }}
    .columns
      .column.is-3.is-strech
        span(:class="parseInt(requisicion.proveedorSel) === 2? 'tag is-black' : ''")
          b Proveedor 2
      .column.is-9.is-strech
        small
          span(:class="parseInt(requisicion.proveedorSel) === 2? 'tag is-black' : ''")
            b {{ requisicion.nombreProv2 }}
          br
          span(:class="parseInt(requisicion.proveedorSel) === 2? 'tag is-black' : ''" v-if="requisicion.monedaP2 ==='0'") 
            b {{requisicion.totalP2 | currency }}
          span(:class="parseInt(requisicion.proveedorSel) === 2? 'tag is-black' : ''" v-else) 
            b USD {{requisicion.totalP2 | currency }}
    .columns
      .column.is-3.is-strech
        span(:class="parseInt(requisicion.proveedorSel) === 3? 'tag is-black' : ''")
          b Proveedor 3
      .column.is-9.is-strech
        small
          span(:class="parseInt(requisicion.proveedorSel) === 3? 'tag is-black' : ''")
            b {{ requisicion.nombreProv3 }}
          br
          span(:class="parseInt(requisicion.proveedorSel) === 3? 'tag is-black' : ''" v-if="requisicion.monedaP3 ==='0'") 
            b {{requisicion.totalP3 | currency }}
          span(:class="parseInt(requisicion.proveedorSel) === 3? 'tag is-black' : ''" v-else) 
            b USD {{requisicion.totalP2 | currency }}
</template>

<script>
  export default {
    name: 'DataRequisicion',
    props: {
      requisicion: {
        type: Object,
        default: {}
      },
    },
  }
</script>

<style lang="css" scoped>
  .column.is-3.is-strech {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .column.is-9.is-strech {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/DataRequisicion.vue